import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./assets/css/main.scss";
import i18n from "./i18n";
import { CHECK_AUTH } from "./store/actions.type";
import ApiService from "./common/api.service";
import ErrorFilter from "./common/error.filter";
import Default from "./views/layouts/Default.vue";
import NoSidebar from "./views/layouts/NoSidebar.vue";
import commentRequest from "./views/Label/commentRequest.vue";
import VueProgressBar from 'vue-progressbar';
import VueFilterDateFormat from 'vue-filter-date-format';
import 'vue-search-select/dist/VueSearchSelect.css';

Vue.use(VueFilterDateFormat);
Vue.use(VueProgressBar, {
  color: '#ee0049',
  failedColor: 'red',
  height: '3px'
});
Vue.config.productionTip = false;
Vue.filter("error", ErrorFilter);

ApiService.init();
router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    "login-default",
    "login",
    "register",
    "ForgotPassword",
    "ResetPassword",
    "VERIFYUSER"
  ];
  const notlogout = !["logout"].includes(to.name);
  const authRequired = !publicPages.includes(to.name);
  const loggedIn = localStorage.getItem("id_token");
  if (authRequired && !loggedIn) {
    return next("/login");
  }
  if (!authRequired && loggedIn) {
    if(!to.params.codeInvit) {
        return next("/home");
    }
  }

  if (!('email' in store.getters.currentUser) || 
    (from.name === "login", to.name === "home") || 
    (from.name === "login", to.name === "sessionlessDeclaration") || 
    (from.name === "login", to.name === "InvestorFormPrincipal")){
    if (authRequired && notlogout)
    Promise.all([store.dispatch(CHECK_AUTH)]).then(next);
    next();
  }else{
    next();
  }
  
});

/*const lang = localStorage.getItem("lang");
if (!lang) {
  window.localStorage.setItem("lang", "fr");
}*/
//window.localStorage.setItem("lang", "fr");

Vue.component("default-layout", Default);
Vue.component("no-sidebar-layout", NoSidebar);
Vue.component("commentRequest", commentRequest);
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
i18n.locale = "fr";
